import React from 'react'
import { Icon, IconButton, useColorMode } from '@chakra-ui/react'
import {
  IconMoon,
  IconSun
} from '_base/Icon'
import ButtonSwitch from '_components/ButtonSwitch'

function ToggleColorMode({ isNormal = true }) {
  const { colorMode, toggleColorMode } = useColorMode()
  return (
    <ButtonSwitch
      transform={isNormal ? '' : 'translateY(-40px)'}
      transition="transform .175s ease"
    >
      {isNormal ? (
        <>
          <IconButton
            aria-label="switch light mode"
            variant={colorMode === 'light' ? 'main' : 'ghost'}
            size="xs"
            icon={<IconSun fontSize="14px" />}
            onClick={toggleColorMode}
          />
          <IconButton
            aria-label="switch dark mode"
            variant={colorMode !== 'light' ? 'main' : 'ghost'}
            size="xs"
            icon={<IconMoon fontSize="14px" />}
            onClick={toggleColorMode}
          />
        </>
      ) : (
        <IconButton
          aria-label="switch light/dark mode"
          variant="ghost"
          size="xs"
          icon={<Icon as={colorMode === 'light' ? IconSun : IconMoon} fontSize="14px" />}
          onClick={toggleColorMode}
        />
      )}
    </ButtonSwitch>
  )
}

export default ToggleColorMode
